type ArtworkDef = {
  name: string;
  file: string;
};

export class Artwork {
  key: string;
  def: ArtworkDef;
  loaded: boolean;

  constructor(key: string, def: ArtworkDef) {
    this.key = key;
    this.def = def;
    this.loaded = false;
  }
}
